var BILLING_TYPES = {
    OWN: 'own',
    EXTERNAL: 'external'
}

module.exports = BILLING_TYPES
